module.exports = __webpack_public_path__ + "static/13 - UIB-9414b1ca3e42b88620d1d397772a1a1e.png";